import postUtils from '@wix/communities-blog-universal/dist/src/post-utils';
import { type NormalizedPost } from '../types';

type BiPost = NormalizedPost & Record<string, any>;

export const isPublished = (post: BiPost) => Number(postUtils.isPublished(post));
export const categoryIds = (post: BiPost) => JSON.stringify(post.categoryIds || []);
export const paidPlanIds = (post: BiPost) => (post.paidPlansGroupIds || []).join(',');
export const paidPlansHasAccess = (post: BiPost) =>
  typeof post.canSeePaidContent === 'undefined' ? null : Number(post.canSeePaidContent);
